<div class="transport-prognosis">

  <div class="chart">
      <div class="svg-container" [innerHtml]="this.data?.chartSvg | trustHtml"></div>
  </div>

</div>
